export default {
    iKnow: '已了解',
    yzmfssb: '驗證碼發送失敗',

    oldEmail: {
        desc1: '當前認證郵箱可用于找回密碼，',
        desc2: '如該郵箱不再適用，請及時更新',
        change: '修改認證郵箱',
    },

    captcha: {
        inputEmailCode: '輸入郵箱驗證碼',
        sentEmailTo: '已發送郵箱驗證碼至：',
        resend: '重新發送',
        notReceive: '收不到驗證碼',
        connectUs: '聯系我們',
        dlkf: '內地客服：',
        xgkf: '香港客服：',
        wrongCaptcha: '驗證碼錯誤或失效，請重新輸入',
        repeatTips: '60s內無須重複獲取驗證碼',
        wrongEmail: '郵箱驗證失敗或已失效，請重新輸入',
        wrongTooMuch: '驗證次數過多，請稍後重試',
    },

    newEmail: {
        changeEmail: '設置新認證郵箱',
        desc: '修改後您可以通過新郵箱找回密碼',
        inputEmail: '請輸入郵箱地址',
        sendCode: '發送確認郵件',
        syncAccountEmail: '同步更新證券賬戶認證的郵箱',
        syncAccountEmailTitle: '同步更新證券賬戶信息說明',
        info1: '您正在更新平台郵箱信息，主要用于登錄賬號和找回密碼。系統將同步更新您的證券賬戶綁定的郵箱。',
        info2: '如您需要爲星財號和證券賬戶設置不同郵箱，請聯系客服修改。',
        dlkf: '內地客服：',
        xgkf: '香港客服：',
        inputCorrectEmail: '請輸入正確的郵箱地址',
        notSameEmail: '新郵箱不可與當前壹致',
    },

    identity: {
        title: '身份驗證',
        desc: '請填寫開戶證件號進行身份驗證，開戶證件號不區分大小寫，且無須輸入括號',
        idNumber: '開戶證件號',
        nextStep: '下一步',
        desc1: '開戶證件號不區分大小寫字母。如是香港身份證無須輸入括號。',
        desc2: '示例如下：',
        example1: '香港身份證：G1234567',
        example2: '內地身份證：12345678901234567X',
        example3: '內地護照：E12345678',
        wrongIdNumber: '身份驗證失敗，請重新輸入',
    },

    result: {
        success: '修改成功',
        desc: '認證郵箱已修改成功',
        finish: '完成',
    },
}
